import { render, staticRenderFns } from "./feedBackAdm.vue?vue&type=template&id=01443ab2&scoped=true&"
import script from "./feedBackAdm.vue?vue&type=script&lang=js&"
export * from "./feedBackAdm.vue?vue&type=script&lang=js&"
import style0 from "./feedBackAdm.vue?vue&type=style&index=0&id=01443ab2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01443ab2",
  null
  
)

export default component.exports